module.exports = __webpack_public_path__ + "media/assets/images/sunny_later_will_snow-924f88d8fd94e9b25b7a7f58838c323d.png";